import React from "react";
import { useSelector } from "react-redux";

//Pages
import OnboardingHomePage from "./OnboardingHomePage/OnboardingHomePage";
import CorporateContactHandler from "./CorporateContact/CorporateContactHandler";
import PropertyContactHandler from "./PropertyContact/PropertyContactHandler";

import { ONBOARDING_USER_TYPE } from "../../utils/onboarding-helper";

const OnboardigHandler = () => {
  const smUser = useSelector((state) => state.api.smData.data);

  const { role_name, user_name } = smUser;

  let renderElement = <></>;
  if (role_name === ONBOARDING_USER_TYPE.CORPORATE_CONTACT) {
    renderElement = <CorporateContactHandler userName={user_name} />;
  } else if (role_name === ONBOARDING_USER_TYPE.PROPERTY_CONTACT) {
    renderElement = <PropertyContactHandler />;
  } else {
    renderElement = <OnboardingHomePage />;
  }

  return renderElement;
};

export default OnboardigHandler;
